import { Row } from './types';
import { sumColumns } from '../common';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';

export const columns: ControlledTableColumns<Row> = [
  {
    content: 'Agency',
    key: 'enterprise_slug',
    width: 80,
  },
  flexColumn({
    content: 'Provider grp.',
    configLabel: 'Provider group',
    key: 'provider_group_title',
    sortable: true,
  }),
  flexColumn({
    content: 'Provider',
    key: 'provider_internal_name',
    required: true,
    sortable: true,
  }),
  flexColumn({
    content: 'Outlet or service cat.',
    key: 'outlet_or_service_category_name',
    sortable: true,
  }),
  ...sumColumns,
];
